import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { TextTotalComponent } from '@pt/components';
import { environment } from '@pt/environment';
import { TransactionChart } from '@pt/models';

@Component({
  selector: 'pt-transaction-metric-total',
  templateUrl: './transaction-metric-total.component.html',
  styleUrls: ['./transaction-metric-total.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TextTotalComponent],
})
export class TransactionMetricTotalComponent {
  chart = input.required<TransactionChart>();

  readonly i18nHeader = computed(() => {
    const { metrics } = this.chart();
    const id = metrics[0]?.id || 'spent';
    return `transactionMetricTotal.header.${id}`;
  });

  readonly sum = computed(() => {
    const { metrics } = this.chart();
    return metrics[0]?.amount || 0;
  });

  readonly coinIconName = `${environment.shortName}-coin`;
}
